import React, { FC, ReactNode } from 'react';
import Tooltip from '../Tooltip';
import { cn } from '@/helpers/classnames';

interface ChipProps {
  name: string;
  onClick?: () => void;
  description?: string;
  filled?: boolean;
  endAdornment?: ReactNode;
  className?: string;
}

const Chip: FC<ChipProps> = ({
  name,
  filled = true,
  onClick,
  description,
  endAdornment,
  className,
}) => {
  const chip = (
    <div
      onClick={onClick}
      className={cn(
        'inline-flex h-8 items-center rounded-full border px-3 text-sm font-semibold tracking-[1.25px] active:opacity-80',
        onClick ? 'cursor-pointer' : 'cursor-default',
        filled
          ? 'border-workorder-500 bg-workorder-500 text-contrast-workorder'
          : 'border-workorder-500 bg-white text-text-900',
        onClick &&
          filled &&
          'hover:bg-workorder-800 hover:text-contrast-workorder',
        onClick && !filled && 'hover:bg-workorder-200',
        className,
      )}
    >
      {name}
      {endAdornment}
    </div>
  );

  if (!description) {
    return chip;
  }

  return (
    <Tooltip label={<span className="whitespace-pre-line">{description}</span>}>
      {chip}
    </Tooltip>
  );
};

export default Chip;
